<div class="card">
    <div *ngIf="!request && !loading" fxLayout="row" fxLayoutAlign="center center">Error Loading Data</div>

<div *ngIf="request" fxLayout="row" fxLayoutAlign="center center">

    <div class="container">
        <div fxLayout="row" fxLayoutAlign="space-between">
            <div style="font-size: x-large; font-weight: 400;" class="my-2">{{"quotation_details"|translate}}: <span class="mx-2">{{request.invoiceReference}}</span></div>
            <div fxFlexAlign="center center" *ngIf="request" [ngStyle.xs]="{padding: '12px', 'font-size.px':11, hieght: 'min-content'}" style="height: min-content; text-align: center; padding: 10px 10px 10px 10px;">{{"quotation_status"|translate}}:
                <span [style.color]="status[request?.status]?.color">
                    {{status[request?.status]?.text }}</span>
            </div>
        </div>

        <div class=" flex flex-col sm:flex-row justify-items-center justify-between   mb-3">
            <div class="flex" style="font-size: large; color: rgb(109, 102, 102);">{{"review_quotation"|translate}}</div>
            <div>
                <a routerLink="/request-quotation" class="sm:mt-0 btn btn-primary">{{"request_quotation"|translate}}</a>
            </div>
        </div>
        <mat-divider class="border border-gray"></mat-divider>
        <div class="my-2">
            <p>{{request.details}}</p>
        </div>

        <mat-divider *ngIf="request.images?.length" class="border border-gray"></mat-divider>

        <ng-container *ngIf="request.images?.length">
            <ng-container *ngFor="let file of request.images;">
                <ng-container *ngIf="isFileImage(file.mimetype); else generalFile">
                    <a class="chat-file" [href]="file.url" target="_blank" style="background-image: url('{{file.url}}');">
                    </a>
                </ng-container>
                <ng-template #generalFile>
                    <a class="chat-file" [href]="file.url" target="_blank">
                        <mat-icon [inline]="true" style="font-size: 3rem;">insert_drive_file</mat-icon>
                        <div class="file-name">{{file.filename}}</div>
                    </a>
                </ng-template>
            </ng-container>
        </ng-container>

        <!-- <div class="flex flex-col">
            <div class="m-2" *ngFor="let item of request.images"><img style="max-width: 100%;" [src]="item.url"></div>

        </div> -->

        <div>



        </div>

    </div>

</div>


</div>
